// Busca geral: além das tarefas, procura nos itens de todas as abas liberadas (campos do cofre ficam de fora).
import type { AbaId, Docs } from '../store/types';
import { MOD_IDS } from '../store/types';
import { DEFS } from '../modulos/defs';
import { ctxDe } from '../modulos/ctx';
import { aba } from '../components/theme';
import { norm } from './date';
import { t } from './i18n';

export type Achado = { aba: AbaId; id: string; titulo: string; detalhe: string; icone: string };

export function buscarNasAbas(docs: Docs, q: string, liberada: (id: AbaId) => boolean, max = 40): Achado[] {
  const k = norm(q.trim());
  if (k.length < 2) return [];
  const tem = (...partes: unknown[]) => norm(partes.filter(x => typeof x === 'string' || typeof x === 'number').join(' ')).includes(k);
  const out: Achado[] = [];
  if (liberada('documentos')) for (const d of docs.documentos?.items ?? [])
    if (tem(d.nome, d.titular, t(d.tipo), d.segredo ? '' : d.orgao, d.segredo ? '' : d.notas)) out.push({ aba: 'documentos', id: d.id, titulo: d.nome?.trim() || t(d.tipo), detalhe: d.titular, icone: '🪪' });
  if (liberada('garantias')) for (const w of docs.garantias?.items ?? [])
    if (tem(w.name, w.store, w.notes, w.supportName)) out.push({ aba: 'garantias', id: w.id, titulo: w.name, detalhe: w.store, icone: '🧾' });
  if (liberada('financas')) for (const c of docs.financas?.contas ?? [])
    if (tem(c.nome, c.notas)) out.push({ aba: 'financas', id: c.id, titulo: c.nome, detalhe: t('Conta'), icone: c.icone || '💰' });
  for (const b of docs.anotacoes?.boxes ?? [])
    if (!b.archivedAt && tem(b.title, ...b.blocks.flatMap(x => [x.text, ...x.items.map(i => i.text)]))) out.push({ aba: b.aba, id: b.ref || b.id, titulo: b.title || t('Sem título'), detalhe: aba(b.aba).nome, icone: '🗒️' });
  for (const mod of MOD_IDS) {
    if (!liberada(mod)) continue;
    const regs = docs[mod]?.regs ?? [];
    const def = DEFS[mod], ctx = ctxDe(mod, regs);
    for (const r of regs) {
      const col = def.colecoes.find(c => c.id === r.col);
      if (!col || col.id === 'chamada') continue;
      const titulo = col.titulo(r, ctx);
      const textos = col.campos.filter(f => f.t !== 'cofre').map(f => (f.t === 'opcao' && r.c[f.k] ? t(r.c[f.k]) : r.c[f.k]));
      if (!tem(titulo, ...textos, ...(r.itens ?? []).map(i => i.text))) continue;
      const pai = r.pai ? ctx.porId(r.pai) : null;
      const cp = pai ? def.colecoes.find(c => c.id === pai.col) : null;
      out.push({ aba: mod, id: r.id, titulo: titulo || t(col.um), detalhe: [aba(mod).nome, pai && cp ? cp.titulo(pai, ctx) : ''].filter(Boolean).join(' › '),
        icone: typeof col.icone === 'function' ? col.icone(r) : col.icone });
    }
  }
  return out.slice(0, max);
}
